import * as Sentry from '@sentry/vue';
import { App } from 'vue';
import { HttpClient } from '@sentry/integrations';

export default function startSentry(
	app: App<Element>,
	dsn: string,
	release: string,
	environment: string
) {
	Sentry.init({
		app: app,
		dsn: dsn,
		beforeBreadcrumb(breadcrumb, hint) {
			if (breadcrumb.category === 'xhr') {
				breadcrumb.data = JSON.parse(
					(hint.xhr as XMLHttpRequest).response
				);
			}
			return breadcrumb;
		},
		integrations: [
			new Sentry.BrowserTracing({
				// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
				tracePropagationTargets: [],
			}),
			new Sentry.Replay({
				maskAllText: false,
				blockAllMedia: false,
			}),
			//@ts-ignore
			new HttpClient({
				failedRequestStatusCodes: [[422, 599]],
			}),
		],
		sendDefaultPii: true,
		release: release,
		environment: environment,
		// Performance Monitoring
		tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
		// Session Replay
		replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
		replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
	});
}
